import gql from 'graphql-tag'

export const datoState = gql`
  query datoState($locale: SiteLocale) {
    allBlogTags(locale: $locale) {
      slug
      title
      id
      _allReferencingArticlesMeta {
        count
      }
    }
    _site(locale: $locale) {
      globalSeo {
        siteName
        fallbackSeo {
          description
          title
          image {
            url(imgixParams: { w: "1200", h: "630" })
          }
          twitterCard
        }
        titleSuffix
      }
    }
  }
`
